/**
 * Lightweight in-memory registry for Coach Steve sub-agents.
 *
 * Phase A uses the registry as a single source of truth for which agents
 * exist (so the router prompt and regex dispatch stay in sync). Agent
 * registration happens once, when the agent module is imported via
 * `agents/index.ts`.
 */

import type { CoachSteveAgent } from './types';

const registry = new Map<string, CoachSteveAgent>();

/** Register a sub-agent. Throws on duplicate names to surface bugs early. */
export function registerAgent(agent: CoachSteveAgent): void {
  if (registry.has(agent.name)) {
    throw new Error(`Coach Steve agent already registered: ${agent.name}`);
  }
  registry.set(agent.name, agent);
}

/** Look up a single agent by name. */
export function getAgent(name: string): CoachSteveAgent | undefined {
  return registry.get(name);
}

/** All registered agents in registration order. */
export function listAgents(): CoachSteveAgent[] {
  return Array.from(registry.values());
}

/** Clear the registry. Test-only convenience; not used at runtime. */
export function _clearAgentRegistry(): void {
  registry.clear();
}
